import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0706cbe2 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _a37568f6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _73ba02f6 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _22d5cd48 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _5657f52e = () => interopDefault(import('../pages/search/documents.vue' /* webpackChunkName: "pages/search/documents" */))
const _09d19b44 = () => interopDefault(import('../pages/search/products.vue' /* webpackChunkName: "pages/search/products" */))
const _0a740e72 = () => interopDefault(import('../pages/catalog/_slug.vue' /* webpackChunkName: "pages/catalog/_slug" */))
const _13fb57e9 = () => interopDefault(import('../pages/documents/_slug/index.vue' /* webpackChunkName: "pages/documents/_slug/index" */))
const _53a616aa = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _ef6a5bc6 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _a6e2ab86 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/catalog",
    component: _0706cbe2,
    name: "catalog___en"
  }, {
    path: "/pl",
    component: _a37568f6,
    name: "index___pl"
  }, {
    path: "/ru",
    component: _a37568f6,
    name: "index___ru"
  }, {
    path: "/search",
    component: _73ba02f6,
    children: [{
      path: "",
      component: _22d5cd48,
      name: "search___en"
    }, {
      path: "documents",
      component: _5657f52e,
      name: "search-documents___en"
    }, {
      path: "products",
      component: _09d19b44,
      name: "search-products___en"
    }]
  }, {
    path: "/uk",
    component: _a37568f6,
    name: "index___uk"
  }, {
    path: "/pl/catalog",
    component: _0706cbe2,
    name: "catalog___pl"
  }, {
    path: "/pl/search",
    component: _73ba02f6,
    children: [{
      path: "",
      component: _22d5cd48,
      name: "search___pl"
    }, {
      path: "documents",
      component: _5657f52e,
      name: "search-documents___pl"
    }, {
      path: "products",
      component: _09d19b44,
      name: "search-products___pl"
    }]
  }, {
    path: "/ru/catalog",
    component: _0706cbe2,
    name: "catalog___ru"
  }, {
    path: "/ru/search",
    component: _73ba02f6,
    children: [{
      path: "",
      component: _22d5cd48,
      name: "search___ru"
    }, {
      path: "documents",
      component: _5657f52e,
      name: "search-documents___ru"
    }, {
      path: "products",
      component: _09d19b44,
      name: "search-products___ru"
    }]
  }, {
    path: "/uk/catalog",
    component: _0706cbe2,
    name: "catalog___uk"
  }, {
    path: "/uk/search",
    component: _73ba02f6,
    children: [{
      path: "",
      component: _22d5cd48,
      name: "search___uk"
    }, {
      path: "documents",
      component: _5657f52e,
      name: "search-documents___uk"
    }, {
      path: "products",
      component: _09d19b44,
      name: "search-products___uk"
    }]
  }, {
    path: "/",
    component: _a37568f6,
    name: "index___en"
  }, {
    path: "/pl/catalog/:slug",
    component: _0a740e72,
    name: "catalog-slug___pl"
  }, {
    path: "/pl/documents/:slug",
    component: _13fb57e9,
    name: "documents-slug___pl"
  }, {
    path: "/pl/news/:slug?",
    component: _53a616aa,
    name: "news-slug___pl"
  }, {
    path: "/pl/product/:slug?",
    component: _ef6a5bc6,
    name: "product-slug___pl"
  }, {
    path: "/ru/catalog/:slug",
    component: _0a740e72,
    name: "catalog-slug___ru"
  }, {
    path: "/ru/documents/:slug",
    component: _13fb57e9,
    name: "documents-slug___ru"
  }, {
    path: "/ru/news/:slug?",
    component: _53a616aa,
    name: "news-slug___ru"
  }, {
    path: "/ru/product/:slug?",
    component: _ef6a5bc6,
    name: "product-slug___ru"
  }, {
    path: "/uk/catalog/:slug",
    component: _0a740e72,
    name: "catalog-slug___uk"
  }, {
    path: "/uk/documents/:slug",
    component: _13fb57e9,
    name: "documents-slug___uk"
  }, {
    path: "/uk/news/:slug?",
    component: _53a616aa,
    name: "news-slug___uk"
  }, {
    path: "/uk/product/:slug?",
    component: _ef6a5bc6,
    name: "product-slug___uk"
  }, {
    path: "/catalog/:slug",
    component: _0a740e72,
    name: "catalog-slug___en"
  }, {
    path: "/documents/:slug",
    component: _13fb57e9,
    name: "documents-slug___en"
  }, {
    path: "/news/:slug?",
    component: _53a616aa,
    name: "news-slug___en"
  }, {
    path: "/pl/:slug",
    component: _a6e2ab86,
    name: "slug___pl"
  }, {
    path: "/product/:slug?",
    component: _ef6a5bc6,
    name: "product-slug___en"
  }, {
    path: "/ru/:slug",
    component: _a6e2ab86,
    name: "slug___ru"
  }, {
    path: "/uk/:slug",
    component: _a6e2ab86,
    name: "slug___uk"
  }, {
    path: "/:slug",
    component: _a6e2ab86,
    name: "slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
